import './styles/stylesheet.css';
import Navbar from './components/Navbar'
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import Timetable from './pages/Timetable';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/de';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Account from './pages/Account';
import Contact from './pages/Contact';
import Results from './pages/Results';
import { AuthProvider, useAuth } from './provider/auth';
import { ToastContainer } from 'react-toastify';
import Tournaments from './pages/Tournaments';
import ResetPassword from "./pages/ResetPassword";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';

// Definiere dein eigenes Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#d32f2f', // Ein kräftiges Rot für Akzente (z.B. Buttons, Filter)
    },
    // Du kannst hier weitere Farben definieren
  },
  components: {
    // Standard-Stil für Paper-Komponenten (wie die Tabelle)
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 12px rgba(0,0,0,0.05)', // Ein sanfter Schatten
          borderRadius: '8px',
        },
      },
    },
  },
});



function App() {
  return (
    
    <BrowserRouter>
      <ToastContainer />
      <AuthProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <ThemeProvider theme={theme}>
          <Routes>
            <Route element={<LayoutWithoutNav />}>
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />}/>
              <Route path="/set-password" element={<ResetPassword />}/>
            </Route>
            <Route element={<LayoutWithNav />}>
              <Route path="/*" element={<ProtectedRoute><Timetable /></ProtectedRoute>} />
              <Route path="/tournaments" element={<ProtectedRoute><Tournaments /></ProtectedRoute>} />
              <Route path="/contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
              <Route path="/admin/*" element={<AdminRoute requiredRole={2}><Admin /></AdminRoute>} />
              <Route path="/account" element={<ProtectedRoute ><Account /></ProtectedRoute>} />
              <Route path="/results" element={<ProtectedRoute ><Results /></ProtectedRoute>} />
            </Route>
          </Routes>
          </ThemeProvider>
        </LocalizationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

const LayoutWithNav = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Navbar />
    <Box 
      component="main" 
      sx={{ 
        flexGrow: 1, 
        p: { xs: 2, md: 3 },
        width: '100%',
        mt: 0 
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

const LayoutWithoutNav = () => <Outlet />;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
};


const AdminRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole !== undefined && user.role < requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
};


export const API_BASE_URL = process.env.REACT_APP_API_URL;

export default App;
